import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { color } from '../templates/Ui';
import { getAppThemeName } from '../../services/appTheme';
export const StyledInput = styled.input `
    transition: all 300ms ease-in-out;
    padding: 15px;
    background-color: white;
    border-radius: 6px;
    border-width: 1px;
    border-style: solid;
    border-color: ${color.border.input};
    width: 100%;
    outline: none;
    font-size: 16px;
    font-weight: 400;
    color: ${props => props.theme.primary.base};
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    ${props => props.activeFilter &&
    getAppThemeName() === 'inkassier' &&
    css `
            border-color: ${props.theme.secondary};
        `};

    ${() => getAppThemeName() === 'inkassier' &&
    css `
            &:not([value='']),
            &:focus {
                border-color: ${props => props.theme.secondary};

                ~ .focus-border {
                    width: 100%;
                }
            }
        `};

    &:focus {
        ~ .focus-border {
            width: 100%;
        }
    }

    &:disabled:focus {
        ~ .focus-border {
            opacity: 0;
        }
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    &[type='number']::-webkit-inner-spin-button,
    &[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &[type='number'] {
        -moz-appearance: textfield;
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
        box-shadow: 0 0 0 30px white inset !important;
    }

    &::placeholder {
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
        opacity: 1;
    }

    &:-ms-input-placeholder {
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
    }

    &::-ms-input-placeholder {
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
    }
`;
const FilterInput = ({ className, value, type, placeholder, activeFilter, ...props }) => (_jsx(StyledInput, { className: className, type: type, value: value, placeholder: placeholder, activeFilter: activeFilter, ...props }));
export default FilterInput;
